import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { NavLink } from 'react-router-dom'

import CollapsiblePanel from 'components/CollapsiblePanel'
import Icon from 'pages/shared/RemoteConfigSessionsPanel/icon'
import { Panel } from 'components/Panel'

import { customerDisplayName } from 'helpers/formatters'

import { color } from 'styles/colors'

import useRemoteConfigSessions from 'hooks/useRemoteConfigSessions'

type Props = {
  className?: string
  sendEventCallback?: (action) => void
}

const RemoteConfigSessionsPanel = ({ className, sendEventCallback = () => {} }: Props) => {
  const { sessions } = useRemoteConfigSessions()

  if (!sessions?.length) {
    return <></>
  }

  return (
    <S.Panel className={className}>
      <S.CollapsiblePanel
        caretHorizontalPosition="left"
        expandedCallback={sendEventCallback('Expand DRC Banner')}
        headerComponent={(
          <S.PanelHeader>
            <S.PanelTitle>
              <S.Icon />

              <span>Remote Connect Sessions</span>
            </S.PanelTitle>
          </S.PanelHeader>
        )}
      >
        { sessions
          .map((session) => (
            <S.Device
              key={session.remoteAccess.requestId}
              onClick={() => sendEventCallback(`Click DRC Session ${session.device.name || session.device.deviceId}`)}
            >
              <S.CustomerName>{customerDisplayName(session.customer.firstName, session.customer.lastName, session.customer.companyName)}</S.CustomerName>
              <div>
                <NavLink to={`/customers/${session.customer.id}/systems/${session.device.deviceId}`}>{session.device.name || session.device.deviceId}</NavLink>
                <div>AUID: {session.device.deviceId}</div>
              </div>
              <S.SessionDetails>
                <S.State>{session.remoteAccess.state}</S.State>
                <S.Expiration>Expires in {moment.duration(moment().diff(session.remoteAccess.expiresAt)).humanize()}</S.Expiration>
              </S.SessionDetails>
            </S.Device>
          ))
         }
      </S.CollapsiblePanel>
    </S.Panel>
  )
}

export default RemoteConfigSessionsPanel

const S = {
  Panel: styled(Panel)`
    padding-bottom: 0;
  `,
  // TODO: Code Smell: This callapsible panel implementation is awkward forcing you to use complicate child element selectors to get styles to work properly.
  // It would be better if it was more composable some how and CSS can be more direct.
  CollapsiblePanel: styled(CollapsiblePanel)`
    & > div:first-of-type {
      padding: 0;
      background-color: ${color('remoteConfigPanelHeaderBackground')};
    }

    & > div:nth-of-type(2) {
      padding: 0;
      margin: 20px 20px 0 20px;
    }
  `,
  PanelTitle: styled(Panel.Title)`
    display: flex;
    align-items: center;
  `,
  PanelHeader: styled(Panel.Header)`
    background-color: ${color('remoteConfigPanelHeaderBackground')};
    color: ${color('remoteConfigPanelHeaderText')};
    margin: 5px 0px;
  `,
  Icon: styled(Icon)`
    margin-right: 10px;
  `,
  Device: styled.div`
    display: inline-block;
    border: 1px solid ${color('border')};
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 250px;
    padding: 10px;
  `,
  SessionDetails: styled.div`
    border-top: 1px solid ${color('border')};
    padding-top: 10px;
    margin-top: 10px;
  `,
  State: styled.div`
    text-transform: uppercase;
    font-weight: bold;
  `,
  Expiration: styled.div`
    float: right;
    margin-top: -21px;
    font-style: italic;
  `,
  CustomerName: styled.div`
    font-wieght: bold;
  `
}
